<p-dialog header="Bid Instruction Queue" #tt
    [modal]="true"
    [responsive]="true"
    [(visible)]="showBidQueDialog" 
    (onHide)="bidQuedialogHide()"
    positionTop="10"
    [contentStyle]="{'width': '800px','min-height':'400px', 'max-height': '640px','overflow-y':'scroll'}">
    
    <p-table #dt [value]="data" 
      [columns]="cols" 
      autoLayout=true 
      [rows]="20" 
      [paginator]="isPaginatorVisible()"
      [totalRecords]="records" 
      [rowsPerPageOptions]="[20,50,100]" 
      [loading]="loading">
    
      <ng-template pTemplate="caption">
        <div style="margin-top: -14px; float: right; display: flex;" *ngIf="data && data.length >0">
          <div style="margin-top: 1.5%;font-size: 0.9em;">
            {{records}} Records Found
          </div>&nbsp;&nbsp;
        </div>
      </ng-template>
    
      <ng-template pTemplate="header">
        <tr #headers>
          <ng-container *ngFor="let col of cols">
            <th *ngIf="col.showInHeader">
              {{col.header}}
            </th>
          </ng-container>
        </tr>
      </ng-template>
    
      <ng-template pTemplate="emptymessage">
        <tr *ngIf="!loading && data && data.length === 0">
          <td [attr.colspan]="10" class="center-align">No records found</td>
        </tr>
      </ng-template>
  
      <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" let-columns="columns">
        <tr>
            <ng-container *ngFor="let col of columns">
                <td *ngIf="col.showInHeader && col.field != 'Loan'" >
                    {{rowData[col.field]}}
                </td>
                <td *ngIf="col.showInHeader && col.field == 'Loan'" >
                   <a href="{{rowData['propertyUrl']}}"> 
                    {{rowData[col.field]}}  
                  </a>
                </td>
            </ng-container>
        </tr>
      </ng-template>
    </p-table>


</p-dialog>